import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.div`
  padding: 30px;
  background: ${theme.colors.mainBg};
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  & > h1 {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: #3C2E21;
  }

  & > div {
    width: 1px;
    height: 20px;
    background: #3C2E21;
  }

  & > p {
    font-family: 'Inter';
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: #3C2E21;
  }
`

export const ShortInfos = styled.div`
  width: 100%;
  padding: 10px 5px 20px;

  background: ${theme.colors.mainBg};

  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;

  @media (max-width: 1359px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 780px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 550px) {
    grid-template-columns: 1fr;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 20px;

  @media (max-width: 1270px) {
    flex-direction: column;
    grid-template-columns: 1fr;
  }
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`

export const Actions = styled.div`
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 710px) {
    justify-content: center;
    margin-top: 20px;
  }
`

export const PeriodFilter = styled.div`
  height: 48px;

  & > button {
    height: 100%;
    padding: 8px 15px;
    background: transparent;
    font-family: ${theme.font.inter};
    font-style: normal;
    font-weight: 400;
    font-size: ${theme.font.sizes.large};
    line-height: ${theme.font.sizes.xxlarge};
    color: #E4E4E4;
    border-bottom: 2px solid ${theme.colors.orange};
  }
`

export const Filters = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
`

export const ButtonFilters = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 4px;
  background: #FCE7DA;
`

export const DownloadButton = styled.button`
  height: 48px;
  width: 200px;

  background: transparent;
  border: 1px solid #A0A5B6;
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 125%;
  /* identical to box height, or 22px */

  display: flex;
  align-items: center;

  /* Cores da marca/Marrom */

  color: #3C2E21;

`

export const DropdownContainer = styled.div`
  width: 331px;

  padding: 24px;

  /* Branco */

  background: #FFFFFF;
  /* Shadow 1 */

  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: 8px;

  position: absolute;
  top: 55px;
  right: 0px;

  display: flex;
  flex-direction: column;
  gap: 15px;

  z-index: 99;
`

export const FilterButton = styled.button`
  width: 100%;
  padding: 18px;
  background: #0172CB;
  box-shadow: 0px 3px 2px rgba(121, 108, 95, 0.22);
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #FFFFFF;
`

export const LabelCheckbox = styled.label`
  display: flex;
  gap: 10px;
`

export const SpanCheckbox = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: #222222;
`

export const FilterTitle = styled.h3`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: #252A31;
`
